import { Tag, Icon, Select } from '@trussworks/react-uswds';
import classNames from 'classnames';
import { UserPermissions, RoleMap } from '@src/utils/enums';
import { useAuthStore } from '@stores';
import { AuthorizedUser } from '@api/services/authorized-user/types';
import InternalLink from '@components/internal-link/InternalLink';

import './UserCard.scss';

type UserCardProps = {
  user: AuthorizedUser;
  onRemoveUser: (user: AuthorizedUser) => void;
  onPermissionsChange: (user: AuthorizedUser, selectedValue: string) => void;
  showSelectRole: boolean;
  showRolePill: boolean;
  showEmailAsLink: boolean;
};

const UserCard = ({
  user,
  onRemoveUser,
  onPermissionsChange,
  showSelectRole = true,
  showRolePill = true,
  showEmailAsLink = false,
}: UserCardProps) => {
  const { getProfile } = useAuthStore();
  const isUser = user?.email === getProfile()?.email;

  const currentUserPermissionStyles = classNames({
    'permissions-tag-owner': user?.permission === UserPermissions.Owner,
    'permissions-tag-write': user?.permission === UserPermissions.ReadWrite,
    'permissions-tag-read': user?.permission === UserPermissions.ReadOnly,
  });

  return (
    <div className='user-card'>
      <div className='user-card__left'>
        <div className='user-card__top-row'>
          <div className='user-card__name'>
            <b>{`${user?.firstName} ${user?.lastName}`}</b>
          </div>
          {showRolePill && user?.permission && (
            <div className='user-card__tags'>
              <Tag className={currentUserPermissionStyles}>
                {RoleMap[user?.permission].toLowerCase()}
                {isUser ? ' - YOU' : ''}
              </Tag>
            </div>
          )}
        </div>
        <div className='user-card__email'>
          {showEmailAsLink ? (
            <InternalLink content={user?.email} title={`MailTo ${user?.email}`} href={`mailto:${user?.email}`} />
          ) : (
            user?.email
          )}
        </div>
      </div>
      {showSelectRole && user?.permission !== UserPermissions.Owner && (
        <div className='user-card__right'>
          <div className='user-card__role_selection'>
            <Select
              name='role'
              id={`user-role_${user?.email}`}
              onChange={(e) => onPermissionsChange(user, e.target.value)}
              value={user?.permission}
            >
              <option value={UserPermissions.Owner}>Project Owner</option>
              <option value={UserPermissions.ReadWrite}>Read/Write</option>
              <option value={UserPermissions.ReadOnly}>Read Only</option>
            </Select>
          </div>
          <div className='user-card__delete' onClick={() => onRemoveUser(user)}>
            <Icon.Delete className=' user-card__delete-icon' aria-hidden='false' />
          </div>
        </div>
      )}
    </div>
  );
};

export default UserCard;
